export const hasPortalSession = (expectedRole) => {
  try {
    if (!localStorage.getItem("ecauthtoken")) return false;
    const sessionRole = localStorage.getItem("portalRole");
    // Sessions created before portalRole was introduced remain valid and will
    // be verified by the portal API. New sessions cannot cross portal trees.
    return !expectedRole || !sessionRole || sessionRole === expectedRole;
  } catch {
    return false;
  }
};

export const shouldClearSessionForLogin = (activePortal, loginPortal) =>
  !activePortal || activePortal === loginPortal;
